import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { Dialog, DialogContent, PrimaryButton } from "@crehana/ui";
import useLiveSubscriptionTranslation from "./hooks/useLiveSubscriptionTranslation";
import { jsx as _jsx } from "react/jsx-runtime";
var LiveSubscriptionConfirmationDialog = function LiveSubscriptionConfirmationDialog(_ref) {
  var isDark = _ref.isDark,
    live = _ref.live,
    isOpen = _ref.isOpen,
    onDismiss = _ref.onDismiss,
    subscriptionMutation = _ref.subscriptionMutation,
    onRetry = _ref.onRetry;
  var _useLiveSubscriptionT = useLiveSubscriptionTranslation(),
    t = _useLiveSubscriptionT.t;
  var mutationSuceeded = subscriptionMutation.status === 'success';
  var dialogContentBaseProps = {
    isDark: isDark,
    type: 's'
  };
  return /*#__PURE__*/_jsx(Dialog, {
    open: isOpen,
    onDismiss: onDismiss,
    isDark: isDark,
    size: "s",
    children: mutationSuceeded ? /*#__PURE__*/_jsx(DialogContent, _objectSpread(_objectSpread({
      className: "flex flex-col items-center text-center",
      mainTitle: t('CONFIRMATION_DIALOG_SUCCESS_TITLE'),
      body: t(live.calendarLink ? 'CONFIRMATION_DIALOG_SUCCESS_DESCRIPTION_WITH_CALENDAR' : 'CONFIRMATION_DIALOG_SUCCESS_DESCRIPTION')
    }, dialogContentBaseProps), {}, {
      children: /*#__PURE__*/_jsx(PrimaryButton, {
        label: t(live.calendarLink ? 'CALENDAR_BUTTON_LABEL' : 'OK_BUTTON_LABEL'),
        onClick: live.calendarLink ? function () {
          if (live.calendarLink) {
            window.open(live.calendarLink);
          }
          onDismiss();
        } : onDismiss,
        isDark: isDark,
        size: "l"
      })
    })) : /*#__PURE__*/_jsx(DialogContent, _objectSpread(_objectSpread({
      className: "flex flex-col items-center text-center",
      mainTitle: t('CONFIRMATION_DIALOG_ERROR_TITLE'),
      body: subscriptionMutation.errorMessage || t('CONFIRMATION_DIALOG_ERROR_DESCRIPTION')
    }, dialogContentBaseProps), {}, {
      children: /*#__PURE__*/_jsx(PrimaryButton, {
        label: t('RETRY_BUTTON_LABEL'),
        onClick: function onClick() {
          return onRetry(live);
        },
        disabled: subscriptionMutation.status === 'loading',
        isDark: isDark,
        size: "l"
      })
    }))
  });
};
export default LiveSubscriptionConfirmationDialog;